<template>
  <div class="section fp-section active fp-completely pt-0" data-anchor="fourth-section">
    <section id="testimonial-area" class="cr-section testimonial-area section-padding-xlg bg-image-5 pt-0">
      <Loading :loaded="loaded"></Loading>
      <div class="container">
        <div class="row">
           <div  v-for="(block,index ) in blocks" class="col-12" v-bind:key="index" >
            <div class="row pos-relative"  v-bind:key="'block-asdsa'+blocks.id" >
              <div class="col-md-6 mt-5 mb-5" v-if="index%2===0">
                <img :src="block.image" :title="block.title">
                <div class="floating-md">{{block.description}}</div>
              </div>
              <div class="col-md-6 offset-md-6 mt-5 mb-5" v-if="index%2!==0">
                <img :src="block.image" :title="block.title">
                <div class="floating-md">{{block.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loading from './Loading'
import ImageLazy from './ImageLazy'

export default {
  name: 'Hihighted.vue',
  data () {
    return {
      loaded: false,
      blocks: []
    }
  },
  components: {
    Loading,
    ImageLazy
  },
  mounted () {
    this.getTopBlock()
    const self = this
    self.$eventHub.$on('language-changed', function () {
      self.getTopBlock()
    })
  },
  computed: {
    menuPrefix: function () {
      return this.$translate.locale === 'en' ? '/en' : ''
    }
  },
  methods: {
    getTopBlock () {
      this.axios.get(this.$host + 'topblock').then(resp => {
        this.blocks = resp.data.data
        this.loaded = true
      }).catch(() => {
        this.loaded = true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Hihighted.vue